import { useQuery } from "@apollo/client";
import { USERNAME_EXISTS } from "./queries";

export const useCheckExistingUsername = username => {
    const {loading, error, data} = useQuery(USERNAME_EXISTS, {variables: {username}});
    if (loading || error) return false;
    return data.usernameExists;
}